export default "__VITE_ASSET__2bf991e0__"